import { render, staticRenderFns } from "./orders-by-delivery-time-chart.vue?vue&type=template&id=0387d668&scoped=true&"
import script from "./orders-by-delivery-time-chart.vue?vue&type=script&lang=js&"
export * from "./orders-by-delivery-time-chart.vue?vue&type=script&lang=js&"
import style0 from "./orders-by-delivery-time-chart.vue?vue&type=style&index=0&id=0387d668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387d668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0387d668')) {
      api.createRecord('0387d668', component.options)
    } else {
      api.reload('0387d668', component.options)
    }
    module.hot.accept("./orders-by-delivery-time-chart.vue?vue&type=template&id=0387d668&scoped=true&", function () {
      api.rerender('0387d668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring/charts/orders-by-delivery-time-chart.vue"
export default component.exports